<template>
  <div class="view_box" :class="isAni ? 'ani':''">
    <div class="title">11.11活动效果回顾</div>
    <div>今年11.11，你<span class="font_color" style="padding-bottom: 3px;">&nbsp;{{ data.isOpenRemind1111 ? "开启了" : "未开启" }}&nbsp;</span>订单催付</div>
    <template v-if="data.isOpenRemind1111">
      <div style="margin-top: 30px;">挽回订单金额：<span class="font_color">&nbsp;{{ data.recoveryAmount1111 }}&nbsp;</span>元</div>
      <div>这是个明智的决策，帮助店铺挽回了部分流失订单！</div>
    </template>
    <template v-else>
      <div style="margin-top: 30px;">好可惜！因为店铺没有开启催付，导致多个订单流失。</div>
      <div>如果开启订单催付，预计至少会挽回60%的订单哦~</div>
    </template>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {
    isAni:{
      type:Boolean,
      default:true,
    },
    data: {
      type: Object,
      default: ()=> {}
    }
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@keyframes view_box_s {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ani{
  animation: view_box_s 1.5s ease-in;
  animation-fill-mode: both;
  border-radius: 16px;
}
.view_box {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 50px;
  font-size: 14px;
  color: #000000;
  line-height: 16px;
  font-family: PingFang SC;
  background-image: url("../../assets/images/yearReport/P8.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  div {
    font-family: PingFang SC;
    width: 100%;
    margin-bottom: 12px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: 28px;
    margin-bottom: 30px;
  }

  .font_color {
    color: #0b79ff;
    font-weight: bold;
    font-size: 18px;
    line-height: 24px;
  }
}
</style>